type PlainLocationHeaders = {
  location?: string
  Location?: string
}

export const getLocationHeader = (headers: unknown): string => {
  if (!headers) {
    return ''
  }

  if (headers instanceof Headers) {
    return headers.get('location') ?? headers.get('Location') ?? ''
  }

  const record = headers as PlainLocationHeaders & {
    get?: (name: string) => string | null
  }

  if (typeof record.get === 'function') {
    return record.get('location') ?? record.get('Location') ?? ''
  }

  return record.location ?? record.Location ?? ''
}
